"use strict";
import SectionBgColor from './modules/sectionBgColor';

window.addEventListener('load', () => {
  // セクション毎で背景色変更
  const sectionBgColor = new SectionBgColor();
});